module.exports = __webpack_public_path__ + "media/applicants/grocerybundle-aed171e7.webp";